import { useState } from "react";
import { API_URL } from "../../utils/common";

export interface CatalogoPerfil {
    id: number;
    nombre: string;
    descripcion?: string;
    estatus?: number;
}

export const useGetCatalogoPerfiles = () => {

    const [perfiles, setPerfiles] = useState<CatalogoPerfil[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const obtenerCatalogoPerfiles = async () => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(`${API_URL}/cms/admin/perfiles`, {
                method: "GET",
                headers: {
                    Authorization: `bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Error al obtener el catálogo de perfiles");
            }

            const data = await response.json();

            setPerfiles(data);

        } catch (err: any) {

            console.error(err);
            setError(err.message || "Ocurrió un error");

        } finally {

            setLoading(false);

        }
    };

    return {
        perfiles,
        loading,
        error,
        obtenerCatalogoPerfiles,
    };
};